import { useNavigate } from 'react-router-dom';

interface UsernameChipProps {
  username?: string | null;
  /** When provided, clicking the chip navigates to /users/{userId}. */
  userId?: string | null;
  /** Compact variant for table cells. */
  compact?: boolean;
}

export default function UsernameChip({ username, userId, compact = false }: UsernameChipProps) {
  const navigate = useNavigate();

  if (!username) {
    return <span className="username-chip username-chip--missing">—</span>;
  }

  const onClick = userId
    ? (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(`/users/${userId}`);
      }
    : undefined;

  return (
    <span
      className={`username-chip${compact ? ' username-chip--compact' : ''}${userId ? ' username-chip--clickable' : ''}`}
      onClick={onClick}
      role={userId ? 'button' : undefined}
      tabIndex={userId ? 0 : undefined}
      onKeyDown={
        userId
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate(`/users/${userId}`);
              }
            }
          : undefined
      }
    >
      @{username}
    </span>
  );
}
